import { SelectMui } from 'src/components/SelectMui'
import styled from 'styled-components'

export const FilterContainer = styled.div`
    display: flex;
    margin-bottom: 1.6rem;
    margin-top: 0.3rem;
    gap: 1.2rem;
    align-items: center;
    width: 40rem;
`

export const CustomSelect = styled(SelectMui)`
    margin: 0 0 1rem 0 !important;
    width: 20%;
    height: 3rem !important;
`

export const CustomSelectWrapper = styled.div`
  display: flex;
  width: 160%;
  gap: 1.4rem;
  margin-bottom: 0;
  height: 3rem !important;
`
